import { Routes } from '@angular/router';

export const CustomerSuccessAdminTabRoutes: Routes = [
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'policy-details',
    loadComponent: () =>
      import('./pages/policy-details/policy-details.component').then((m) => m.PolicyDetailsSearchComponent),
  },
  {
    path: 'policy-number',
    loadComponent: () =>
      import('./pages/policy-number/policy-number.component').then((m) => m.PolicyNumberSearchComponent),
  },
  {
    path: 'policy-number/:policyNumber',
    loadComponent: () =>
      import('./pages/policy-number/policy-number.component').then((m) => m.PolicyNumberSearchComponent),
  },
  {
    path: 'user-details',
    loadComponent: () => import('./pages/user-details/user-details.component').then((m) => m.UserDetailsComponent),
  },
  {
    path: 'user-details/:userDocId',
    loadComponent: () => import('./pages/user-details/user-details.component').then((m) => m.UserDetailsComponent),
  },
  {
    path: 'appointments',
    loadComponent: () =>
      import('./pages/appointments/appointment-management.component').then((m) => m.AppointmentManagementComponent),
  },
  {
    path: 'appointments/:userDocId',
    loadComponent: () =>
      import('./pages/appointments/appointment-management.component').then((m) => m.AppointmentManagementComponent),
  },
  {
    path: 'policy-sync',
    loadComponent: () => import('./pages/policy-sync/policy-sync.component').then((m) => m.PolicySyncComponent),
  },
  {
    path: 'policy-sync/:userDocId',
    loadComponent: () => import('./pages/policy-sync/policy-sync.component').then((m) => m.PolicySyncComponent),
  },
  {
    path: 'change-email',
    loadComponent: () => import('./pages/change-email/change-email.component').then((m) => m.ChangeEmailComponent),
  },
  {
    path: 'change-email/:userDocId',
    loadComponent: () => import('./pages/change-email/change-email.component').then((m) => m.ChangeEmailComponent),
  },
  {
    path: 'customer-number',
    loadComponent: () =>
      import('./pages/customer-number/customer-number.component').then((m) => m.CustomerNumberComponent),
  },
  {
    path: 'customer-number/:userDocId',
    loadComponent: () =>
      import('./pages/customer-number/customer-number.component').then((m) => m.CustomerNumberComponent),
  },
  {
    path: 'customer-lookup',
    loadComponent: () =>
      import('./pages/customer-lookup/customer-lookup.component').then((m) => m.CustomerLookupComponent),
  },
  {
    path: 'customer-lookup/:customerNumber',
    loadComponent: () =>
      import('./pages/customer-lookup/customer-lookup.component').then((m) => m.CustomerLookupComponent),
  },
  {
    path: 'user-record',
    loadComponent: () => import('./pages/user-record/user-record.component').then((m) => m.UserRecordComponent),
  },
  {
    path: 'user-record/:userDocId',
    loadComponent: () => import('./pages/user-record/user-record.component').then((m) => m.UserRecordComponent),
  },
  {
    path: 'pet-breed',
    loadComponent: () => import('./pages/pet-breed/pet-breed.component').then((m) => m.PetBreedComponent),
  },
  {
    path: 'pet-breed/:userDocId',
    loadComponent: () => import('./pages/pet-breed/pet-breed.component').then((m) => m.PetBreedComponent),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./pages/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
  },
  {
    path: 'reset-password/:userDocId',
    loadComponent: () =>
      import('./pages/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
  },
  {
    path: 'verify-email',
    loadComponent: () => import('./pages/verify-email/verify-email.component').then((m) => m.VerifyEmailComponent),
  },
  {
    path: 'verify-email/:userDocId',
    loadComponent: () => import('./pages/verify-email/verify-email.component').then((m) => m.VerifyEmailComponent),
  },
];
